import styles from './Spinner.module.css';

const Spinner = ({ containerClass, spinnerClass }) => {
  return (
    <div className={`${styles.container} ${containerClass}`}>
      <div className={`${styles.spinner} ${spinnerClass}`}></div>
    </div>
  );
};

Spinner.defaultProps = {
  containerClass: '',
  spinnerClass: '',
};

export default Spinner;
